import { render, staticRenderFns } from "./ticker-tape.vue?vue&type=template&id=e4cc2e4c"
import script from "./ticker-tape.vue?vue&type=script&lang=js"
export * from "./ticker-tape.vue?vue&type=script&lang=js"
import style0 from "./ticker-tape.vue?vue&type=style&index=0&id=e4cc2e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports